export interface TargetAudienceRouter {
  goToList(query?: string): void;
  goToCreate(accountId: string): void;
  goToUpdate(id: string, accountId: string): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TargetAudienceRouter = Symbol('TargetAudienceRouter');
